<app-dashini></app-dashini>

<!-- Modal de tokens -->
<div class="modal fade" tabindex="-1" role="dialog" [class.show]="mostrarModalTokens"
  [ngStyle]="{ display: mostrarModalTokens ? 'block' : 'none' }">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg" style="overflow: visible; border-radius: 0">
      <!-- HEADER rojo sobresaliente sin bordes redondeados -->
      <div class="modal-header text-white" style="
          background-color: #b71c1c;
          padding: 15px 60px;
          border-bottom: none;
          display: flex;
          align-items: center;
          font-weight: 600;
          margin: -40px -10px 0 -10px;
          border-radius: 0; /* cuadrado */
        ">
        <h5 class="modal-title" style="font-size: 18px; margin: 0">
          <i class="bi bi-exclamation-triangle-fill me-2" style="font-size: 20px"></i>
          Configuración de Tokens
        </h5>
      </div>

      <!-- CUERPO -->
      <div class="modal-body">
        <p class="mb-3">
          ⚠️ No has registrado alguno de los tokens requeridos:
        </p>

        <ul class="list-group list-group-flush">
          <li class="list-group-item d-flex align-items-center" *ngIf="!usuarioLogueado?.token_personal">
            <img src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png" alt="Git Logo"
              width="20" height="20" class="me-2" />
            <strong>Git</strong>
          </li>

          <li class="list-group-item d-flex align-items-center" *ngIf="!usuarioLogueado?.token_azure">
            <img src="./assets/img/Microsoft_Azure.svg.png" alt="Azure Logo" width="20" height="20" class="me-2" />
            <strong>Azure</strong>
          </li>
        </ul>
      </div>

      <!-- FOOTER -->
      <div class="modal-footer justify-content-center" style="border-radius: 0">
        <p class="mb-3">¿Deseas registrarlo ahora?</p>

        <button type="button" class="btn btn-danger btn-sm px-4 me-5"
          style="background-color: #b71c1c; border-color: #b71c1c" (click)="cerrarModal()">
          Más tarde
        </button>

        <button type="button" class="btn btn-danger btn-sm px-4"
          style="background-color: #b71c1c; border-color: #b71c1c" (click)="irALaURL()">
          Aceptar
        </button>
      </div>
    </div>

    <!-- Fondo oscuro -->
    <div class="modal-backdrop fade show" *ngIf="mostrarModalTokens"
      [ngStyle]="{ 'background-color': 'rgba(0, 0, 0, 0.85)' }"></div>
  </div>
</div>
